import { useDispatch } from 'react-redux'
import { useQueryClient } from '@tanstack/react-query'
import { useAppSelector } from '@core/Store/hooks'
import { getTrustedDeviceDetails } from '@core/Areas/Login/Store/selectors'
import { rememberTrustedDevice } from '@core/Areas/Login/Store'
import { registerTrustedDevice } from '@core/Areas/Login/helpers/api'
import { mfaDevicesQueryKey } from './useMfaDevices'

export const useTrustDevice = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const trustedDevices = useAppSelector(getTrustedDeviceDetails)

  async function trustDevice(accountNumber: number): Promise<void> {
    const trustedDevice = trustedDevices[accountNumber]

    if (!trustedDevice) return

    const { deviceKey, deviceGroupKey, deviceSecret } = trustedDevice
    const accountIdentifier = accountNumber.toString()

    await registerTrustedDevice({
      deviceGroupKey,
      deviceKey,
      deviceSecret,
    })

    dispatch(
      rememberTrustedDevice({
        accountIdentifier,
      })
    )

    queryClient.invalidateQueries({
      queryKey: mfaDevicesQueryKey(accountNumber),
    })
  }
  return { trustDevice }
}
